var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.value)?_c('v-icon',{attrs:{"color":"success"},domProps:{"textContent":_vm._s('mdi-check-circle')}}):_vm._e(),_vm._t("default"),_vm._v(_vm._s(_vm.label))],2)}
var staticRenderFns = []

export { render, staticRenderFns }